import React, { FC, useState } from 'react'
import { formatNumberWithAbbreviation } from '../config/randomInt'

interface Props {
  className?: string
  placeholder?: string
  value?: string
  onChange?: (value: string) => void
  pdfMode?: boolean
  isNumber?: boolean
  isTotal?: boolean
}

const EditableInput: FC<Props> = ({ className, placeholder, value, onChange, pdfMode, isNumber, isTotal }) => {
  const [isFocused, setIsFocused] = useState(false);

  const displayValue = () => {
    if (!value) return '';
    if (isNumber) {
      if (isFocused) {
        // While typing, just show commas to help them read
        const cleaned = value.toString().replace(/,/g, '');
        const parts = cleaned.split('.');
        if (parts[0] !== undefined && !isNaN(parseInt(parts[0]))) {
           parts[0] = parseInt(parts[0]).toLocaleString('en-US');
           return parts.join('.');
        }
        return value;
      } else {
        // Not focused, show abbreviation if applicable
        return formatNumberWithAbbreviation(value, isTotal);
      }
    }
    return value;
  }

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(true);
    const target = e.target;
    setTimeout(() => {
      target.select();
    }, 10);
  };

  const widthClassMatch = className?.match(/\bw-(auto|\d+)\b/);
  const widthClass = widthClassMatch ? widthClassMatch[0] : '';
  const otherClasses = className ? className.replace(/\bw-(auto|\d+)\b/g, '').trim() : '';

  const inputElement = (
    <input
      type="text"
      className={'input ' + (isNumber && !pdfMode ? otherClasses : (className || ''))}
      placeholder={placeholder || ''}
      value={displayValue()}
      onFocus={handleFocus}
      onBlur={() => setIsFocused(false)}
      onChange={onChange ? (e) => onChange(e.target.value) : undefined}
      style={isNumber && isFocused && !pdfMode ? {
        position: 'absolute',
        top: 0,
        right: 0,
        minWidth: '100%',
        width: `max(100%, ${displayValue().toString().length + 2}ch)`,
        zIndex: 50,
        backgroundColor: '#fff9c4', // Light yellow highlighting
        boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
        margin: 0,
      } : (isNumber && !pdfMode ? { width: '100%' } : undefined)}
    />
  );

  if (isNumber && !pdfMode) {
    return (
      <div className={`editable-input-wrapper ${widthClass}`} style={{ position: 'relative', display: 'inline-block' }}>
        {inputElement}
      </div>
    );
  }

  return inputElement;
}

export default EditableInput
